<template>
  <div class="container">
    <div class="container__wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  .container {
    position: absolute;
    width: 100%;
    height: 100%;
    padding-top: 185px;
    padding-bottom: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    &__wrapper {
      display: block;
      position: relative;
      flex-grow: 1;
    }
    @include respond-to(tabletRotate) {
      padding-top: 140px;
    }
    @include respond-to(tablet) {
      padding-top: 120px;
    }
    @media screen and (max-width: $tabletRotate) and (max-height: $r-h) {
      padding-top: 100px;
    }
    @media screen and (max-height: $m-h) {
      padding-top: 75px;
    }
    @media screen and (max-height: $sm-h) {
      padding-top: 55px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CenterContainer.vue